import { EditableText, defineBlock } from "eddev/blocks"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Heading } from "@components/atoms/Heading"
import { Link } from "eddev/routing"
import { CARET_RIGHT } from "@components/atoms/Icons"

export const meta: BlockMeta = {
  title: "Quick links",
  category: "common",
  icon: "admin-links",
  keywords: ["quick links"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("general/quick-links", (props) => {
  return (
    <div className="grid-auto gap-4 py-6">
      <div className="col-span-12">
        <EditableText
          store="title"
          as="h4"
          className="!type-label-caps !text-mid-grey !text-center !mb-4"
          placeholder="Enter title..."
          defaultValue="Quick links"
        />
      </div>
      {props.links?.map((link, i) => (
        <div className="col-span-12 md:col-span-4" key={i}>
          {link?.__typename === "Page" && (
            <QuickLink title={link.title!} uri={link.uri!} image={link?.nextHeroimage ?? undefined} />
          )}
        </div>
      ))}
    </div>
  )
})

const QuickLink = ({ uri, title, image }: { uri: string; title: string; image?: string }) => {
  return (
    <div
      className={
        "w-full flex rounded-md gap-4 relative overflow-hidden bg-white border border-grey p-4 md:p-2 " +
        "transition-[transform,box-shadow] ease-movement duration-300 [&_a]:no-underline " +
        "[&_img]:transition-transform [&_img]:ease-movement [&_img]:duration-300 " +
        "[&_video]:transition-transform [&_video]:ease-movement [&_video]:duration-300 " +
        "hover:-translate-y-[3px] hover:shadow-[0px_6px_12px_0px_rgba(34,34,34,0.08),0px_1px_3px_0px_rgba(34,34,34,0.1)] " +
        "[&:hover_img]:scale-105 [&:hover_video]:scale-105"
      }
    >
      {uri && <Link href={uri} className="absolute inset-0" />}
      {image && (
        <div className="w-10 h-10 rounded-[6px] overflow-hidden">
          <ResponsiveImage mediaItemUrl={image.replace("http://", "//")} aspect={1} />
        </div>
      )}
      <div className="flex grow items-center [&_h5]:type-title-xs">
        <Heading as="h5">{title}</Heading>
        <i>{CARET_RIGHT}</i>
      </div>
    </div>
  )
}
